import React from 'react';
import {
  IUseCrmSearchDirectoryEntriesParams,
  useCrmSearchDirectoryEntries,
} from 'services/CrmApi/queries/useCrmSearchDirectoryEntries';
import { ECrmDirectoryEntryType, IDirectoryEntrySimpleSearchResult } from 'services/CrmApi/types/DirectoryEntry';
import { useDebounce } from 'hooks/useDebounce';
import { InternalDirectoryEntriesSearch } from './InternalDirectoryEntriesSearch';

interface IProps {
  value: string;
  onChange: (value: string | null, directoryEntry?: IDirectoryEntrySimpleSearchResult) => void;
  directoryEntryType: ECrmDirectoryEntryType;
  excludeIds?: string[];
  className?: string;
  linkedDirectoryEntryId?: string;
}

export const ExistingDirectoryEntriesSimpleSearch: React.FC<IProps> = ({
  value,
  onChange,
  directoryEntryType,
  excludeIds = [],
  className,
  linkedDirectoryEntryId,
}) => {
  const [searchTerm, setSearchTerm, debouncedSearchTerm] = useDebounce(value, 500);

  const params: IUseCrmSearchDirectoryEntriesParams = {
    filter: {
      term: debouncedSearchTerm ?? '',
      directoryEntryType: directoryEntryType,
      linkedDirectoryEntryId: linkedDirectoryEntryId,
    },
    pagination: {
      limit: 100,
      offset: 0,
    },
  };
  const { crmDirectoryEntries, directoryEntries } = useCrmSearchDirectoryEntries(params);

  return (
    <InternalDirectoryEntriesSearch
      value={value}
      onChange={onChange}
      className={className}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      excludeIds={excludeIds}
      directoryEntries={directoryEntries}
      isFetching={crmDirectoryEntries.isFetching}
      isFetched={crmDirectoryEntries.isFetched}
    />
  );
};
